// Generated requests validate DTOs, responses, cache keys and cancellation.
export {
  getGetTeamTimelineQueryOptions as getTeamTimelineQueryOptions,
  getGetScheduleQueryOptions as getScheduleQueryOptions,
  getGetScheduleTimelineQueryOptions as getScheduleTimelineQueryOptions,
  getGetTeamDutyQueryOptions as getTeamDutyQueryOptions,
  getGetOwnDutyQueryOptions as getOwnDutyQueryOptions,
  getGetOwnDutyCalendarQueryOptions,
  getOwnDuty,
  getOwnScheduleTeams,
  getGetOwnScheduleTeamsQueryOptions as getOwnScheduleTeamsQueryOptions,
} from './generated/schedules/schedules.js';

import { ApiError } from './client.js';
export function scheduleReadError(error: unknown): string | undefined {
  if (!error) return undefined;
  if (error instanceof ApiError && error.status === 403)
    return 'You do not have permission to view these schedules.';
  if (error instanceof ApiError)
    return 'Schedule information is unavailable. No coverage conclusion can be made.';
  return 'Schedule information could not be loaded. Check your connection and retry.';
}

export {
  getListTeamSchedulesQueryOptions as getTeamSchedulesQueryOptions,
  getGetEligibleScheduleAgentsQueryOptions as getEligibleScheduleAgentsQueryOptions,
} from './generated/schedules/schedules.js';
import {
  createSchedule as createScheduleRequest,
  renameSchedule as renameScheduleRequest,
  createRoutine as createRoutineRequest,
  previewRoutineCreate as previewCreateRequest,
  previewRoutineChange as previewRequest,
  confirmRoutineChange as confirmRequest,
} from './generated/schedules/schedules.js';
import {
  scheduleCreateSchema,
  scheduleRenameSchema,
  routineCreateSchema,
  routineCreatePreviewRequestSchema,
  routineCreatePreviewResponseSchema,
  routineChangePreviewSchema,
  routineChangeConfirmSchema,
  schedulePreviewSchema,
} from '@solidops/shared/schedules';
import type { z } from 'zod';
type CommandAuth = { csrfToken: string; idempotencyKey: string };
const headers = (auth: CommandAuth) => ({
  headers: { 'x-csrf-token': auth.csrfToken, 'idempotency-key': auth.idempotencyKey },
});
export const createSchedule = (
  teamId: string,
  input: z.input<typeof scheduleCreateSchema>,
  auth: CommandAuth,
) => createScheduleRequest(teamId, scheduleCreateSchema.parse(input), headers(auth));
export const renameSchedule = (
  scheduleId: string,
  input: z.input<typeof scheduleRenameSchema>,
  auth: CommandAuth,
) => renameScheduleRequest(scheduleId, scheduleRenameSchema.parse(input), headers(auth));
export const createRoutine = (
  scheduleId: string,
  input: z.input<typeof routineCreateSchema>,
  auth: CommandAuth,
) => createRoutineRequest(scheduleId, routineCreateSchema.parse(input), headers(auth));
export async function previewRoutine(
  routineId: string,
  input: z.input<typeof routineChangePreviewSchema>,
  auth: CommandAuth,
) {
  return schedulePreviewSchema.parse(
    await previewRequest(routineId, routineChangePreviewSchema.parse(input), headers(auth)),
  );
}
export const confirmRoutine = (
  routineId: string,
  input: z.input<typeof routineChangeConfirmSchema>,
  auth: CommandAuth,
) => confirmRequest(routineId, routineChangeConfirmSchema.parse(input), headers(auth));

export {
  getGetOverrideTimeOptionsQueryOptions as getOverrideTimeOptionsQueryOptions,
  getGetRoutineOverrideQueryOptions as getRoutineOverrideQueryOptions,
} from './generated/schedules/schedules.js';
import {
  createRoutineOverride,
  updateRoutineOverride,
  cancelRoutineOverride,
} from './generated/schedules/schedules.js';
import {
  overrideCreateSchema,
  overrideUpdateSchema,
  overrideCancelSchema,
} from '@solidops/shared/schedules';
export const createOverride = (
  routineId: string,
  input: z.input<typeof overrideCreateSchema>,
  auth: CommandAuth,
) => createRoutineOverride(routineId, overrideCreateSchema.parse(input), headers(auth));
export const updateOverride = (
  overrideId: string,
  input: z.input<typeof overrideUpdateSchema>,
  auth: CommandAuth,
) => updateRoutineOverride(overrideId, overrideUpdateSchema.parse(input), headers(auth));
export const cancelOverride = (
  overrideId: string,
  input: z.input<typeof overrideCancelSchema>,
  auth: CommandAuth,
) => cancelRoutineOverride(overrideId, overrideCancelSchema.parse(input), headers(auth));

import { previewScheduleArchive, archiveSchedule } from './generated/schedules/schedules.js';
import {
  scheduleArchiveSchema,
  scheduleVersionRequestSchema,
  scheduleArchivePreviewSchema,
} from '@solidops/shared/schedules';
export async function previewArchive(
  scheduleId: string,
  input: z.input<typeof scheduleVersionRequestSchema>,
  auth: CommandAuth,
) {
  return scheduleArchivePreviewSchema.parse(
    await previewScheduleArchive(
      scheduleId,
      scheduleVersionRequestSchema.parse(input),
      headers(auth),
    ),
  );
}
export const confirmArchive = (
  scheduleId: string,
  input: z.input<typeof scheduleArchiveSchema>,
  auth: CommandAuth,
) => archiveSchedule(scheduleId, scheduleArchiveSchema.parse(input), headers(auth));

export async function previewRoutineCreate(
  scheduleId: string,
  input: z.input<typeof routineCreatePreviewRequestSchema>,
  auth: CommandAuth,
  signal?: AbortSignal,
) {
  return routineCreatePreviewResponseSchema.parse(
    await previewCreateRequest(scheduleId, routineCreatePreviewRequestSchema.parse(input), {
      ...headers(auth),
      ...(signal ? { signal } : {}),
    }),
  );
}
